export default __webpack_public_path__ + "static/media/space.2c4c04e1.svg";